import { useAtomValue } from "jotai";
import { useEffect, useRef } from "react";
import { useSnowplowContext } from "@simplybusiness/services";
import { questionnaireCombinedErrorsAtom } from "../state/questionnaireCombinedErrorsAtom";

export const useQuestionValidationTracking = () => {
  const { snowplow } = useSnowplowContext();
  const errors = useAtomValue(questionnaireCombinedErrorsAtom);
  const reportedErrors = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!errors || !snowplow) return;

    Object.keys(errors).forEach(questionName => {
      if (!reportedErrors.current.has(questionName)) {
        reportedErrors.current.add(questionName);
        snowplow.trigger("questionValidationFailed", {
          question: questionName,
          errorMessage: errors[questionName],
        });
      }
    });

    reportedErrors.current.forEach(questionName => {
      if (!errors[questionName]) {
        reportedErrors.current.delete(questionName);
      }
    });
  }, [errors, snowplow]);
};
